import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
import { ViewChild, ElementRef, NgZone } from '@angular/core'
import { createRenderer, CHANGED_CELL_COLOR } from './plugins/cell_renderer'
//import { initialize as initFilterEventFunction, refresh as filterRefresh } from './plugins/filtering'
//import { initialize as initSortEventFunction, refresh as sortRefresh} from './plugins/sorting'
import { setGroupingHeader, initCollapseSection } from './plugins/grouping'
import { BindingInfo, parseBindingPaths } from '../binding'
import { preprocessors } from './preprocessors'
import { processor as expression_in_data  } from './preprocessors/expression'
declare var Handsontable
/**
 * スプレッドシート
 *【内容:content:any】
 *【更新項目:updatedItems:{[key:string]:any}】
 *【幅:width:number = 1000】
 *【高さ:height:number = 800】
 *【折り返して表示:wrapText:boolean = true】
 *【幅自動補正:resizeWidth:boolean = true】
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-spread-sheet',
  templateUrl: './spread-sheet.html',
  styles: [`

  `]
})
export class SpreadSheet extends BaseWidget {
  /**
   * 更新項目の表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 更新項目に対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * 更新項目
   */
  @Input() updatedItems:{[key:string]:any}

  /**
   * 幅
   */
  @Input() width:number = 1000

  /**
   * 高さ
   */
  @Input() height:number = 800

  /**
   * Handsontable組み込み数式の使用
   */
  @Input() usesBuiltInFormula:boolean = true

  /**
   * カスタムプリプロセッサ
   */
  @Input() customPreprocessor:string = 'fast_calc'

  /**
   * 折り返して表示
   */
  @Input() wrapText:boolean = true

  /**
   * 幅自動補正
   */
  @Input() resizeWidth:boolean = true

  /**
   * スクロール高さ補正値(px)
   */
  @Input() scrollRegionHeightAdjustment:number = 0

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
    public ngZone: NgZone,
  ) {
    super(injector)
  }
  hotTable:any
  @ViewChild('hotTable') hookPoint:ElementRef
  bindingPaths:BindingInfo[][] = []

  /**
   * セル定義
   */
  cellProps: any

  /**
   * オプション
   */
  options: any;
  filterOptions: any[]


  /** 現在グループ化で非表示状態の行  */
  currentHiddenRows: number[] = [];
  /**
   * cell高さ
   */
  public CELL_HEIGHT:number = 30

  /**
   * License Key
   */
  private LICENSE_KEY = 'cad4e-d07bb-fe9a3-c422b-f3e32'

  /**
   * APIからのレスポンスを元にした列のグルーピング設定
   * level:グルーピング階層の深さ
   * start:階層の始まりのカラム
   * end:階層の終わりのカラム
   * isOpen:表示されていればTrue
   */
  private colGroupSettings:{level:number ,start:number, end?:number, isOpen?:boolean}[] = [];

  /**
   * APIからのレスポンスを元にした行のグルーピング設定
   * level:グルーピング階層の深さ
   * start:階層の始まりのカラム
   * end:階層の終わりのカラム
   * isOpen:表示されていればTrue
   */
  private rowGroupSettings:{level:number ,start:number, end?:number, isOpen?:boolean}[] = [];

  private lastUpdate:number = 0

  public currentHeight = 0

  private preprocess:(data:any[][]) => void

  private mainPreprocess:(data:any[][]) => void

  private calcCells: any = {promise: null, lexer: null};

  private preprocessRefersCells:boolean[][] = []

  private subareaIndex:{[subareaId:string]:string[]} = {}

  /** undo機能で戻すセルデータをスタックする **/
  private undoStack = []

  /**
   * 内容
   */
  @Input() set content(content:any) {
    if (this.lastUpdate === content.lastUpdate) return
    this.lastUpdate = content.lastUpdate
    this.render(content)
  }
  @Input()
  set cellContent(cellContent: {row: number, col:number, value: any}[]) {
    if (!cellContent || cellContent.length === 0 || !this.hotTable) return
    while (cellContent.length !== 0) {
      const content = cellContent.pop()
      const startRow = content.row || 0,
            startCol = content.col,
            endRow = !content.row && content.row !== 0 ? this.hotTable.countRows() - 1 : content.row,
            endCol = content.col
      this.updateDataAtRange(startRow, startCol, endRow, endCol, content.value)
    }
  }

  updateDataAtRange(startRow:number, startCol:number, endRow:number, endCol:number, value:any) {
    if (startRow === endRow && startCol === endCol) {
      this.hotTable.setDataAtCell(startRow, startCol, value)
    } else {
      const input = []
      for (let i = startCol; i <= endCol; i++) {
        input.push(value)
      }
      this.hotTable.populateFromArray(startRow, startCol, [input], endRow, endCol, 'Autofill.fill', 'overwrite', 'down')
    }
  }

  mergeDiffs(matrix:any[][], diff:any[][], offsetRow:number, offsetCol:number) {
    for (let i = 0, maxRow = Math.min(matrix.length - offsetRow, diff.length); i < maxRow; i++) {
      const row = matrix[i + offsetRow]
      const diffRow = diff[i]
      for (let j = 0, maxCol = Math.min(row.length - offsetCol, diffRow.length); j < maxCol; j++) {
        const value = diff[i][j]
        if (value != null) {
          row[j + offsetCol] = value
        }
      }
    }
  }

  isChanged(oldValue:any, newValue:any) {
    if (oldValue != newValue) {
      return true
    }
    return (oldValue === 0 || newValue ===0) && (oldValue !== newValue)
  }

  render(content:any):void {
    if (!content || !content.data || !content.cellProps) return
    const props = content.cellProps
    const nestedHeaders = content.nestedHeaders
    const data:any[][] = content.data.map(row => !row ? [] : row.map(col => (col == null) ? "" : col))
    const startRowNum = props.startRowNum
    const endRowNum = props.endRowNum
    const startColNum = props.startColNum
    const endColNum = props.endColNum
    const subareaId = content.subareaId
    const lastActivatedModelPath = props.lastActivatedModelPath
    props.constraintDefs = props.constraintDefs.map(r => !r ? [] : typeof r === 'string' ? JSON.parse(r) : r)
    if (subareaId) {
      const pattern = /(^|\.)([0-9]+)($|[.|])/
      const indices:string[] = this.subareaIndex[subareaId]
      const activePos = props.subareaEnclosingGroupTop ? Number(props.subareaEnclosingGroupTop) : Number(lastActivatedModelPath.match(pattern)[2])
      let found:string = ''
      for (let i=0, len=indices.length; i < len; i++) {
        const index = indices[i]
        const m = index.match(pattern)
        const pos = Number(m[2])
        if (pos === activePos) {
          found = index
          break
        }
        else if (pos > activePos) {
          found = indices[i-1]
          break
        }
      }
      const headerEndRowNum = this.cellProps.headerEndRowNum
      const targetRow = Number(found.split('|')[1])
      const targetRowOffset = (headerEndRowNum || headerEndRowNum === 0) ? headerEndRowNum + 1 : 0
      const targetCol = Number(found.split('|')[2])
      this.mergeDiffs(this.options.data, data.map(r=>r.map(c=> (c + '').startsWith("=") ? null : c)), (targetRow - targetRowOffset), targetCol)
      if (this.cellProps.colorPalette && props.bgColor && props.fgColor) {
        const palletSize = this.cellProps.colorPalette.length
        this.cellProps.colorPalette.push(...props.colorPalette)
        this.mergeDiffs(this.cellProps.bgColor, props.bgColor.map(r=>r.map(c=> (c == null) ? null : c + palletSize)), targetRow, targetCol)
        this.mergeDiffs(this.cellProps.fgColor, props.fgColor.map(r=>r.map(c=> (c == null) ? null : c + palletSize)), targetRow, targetCol)
      }
      if (props.locked) {
        this.mergeDiffs(this.cellProps.locked, props.locked.map(r => r || []), targetRow, targetCol)
      }
      const constraintDefSize = this.cellProps.constraintDefs.length
      this.cellProps.constraintDefs.push(...props.constraintDefs)
      this.mergeDiffs(this.cellProps.constraint, props.constraint.map(r=>r.map(c=> (c == null) ? null : c + constraintDefSize)), targetRow, targetCol)
      if (nestedHeaders && nestedHeaders.length > 0) {
        const hotSettings = this.hotTable.getSettings();
        const groupHeaderCount = this.options.nestedHeaders.length - nestedHeaders.length
        const nestedHeadersHotTable = hotSettings.nestedHeaders;
        for (let i = groupHeaderCount; i < this.options.nestedHeaders.length; i++) {
          this.options.nestedHeaders[i] = nestedHeaders[i - groupHeaderCount]
          nestedHeadersHotTable[i] = nestedHeaders[i - groupHeaderCount]
        }

        // Refresh Nested Headers
        const nestedHeadersPlugin = this.hotTable.getPlugin('nestedHeaders');
        nestedHeadersPlugin.updatePlugin();
        // Refresh Hidden Columns
        const hiddenColumnsPlugin = this.hotTable.getPlugin('hiddenColumns');
        var hiddenAndCollapsedCols = [];
        Array.prototype.push.apply(hiddenAndCollapsedCols, hiddenColumnsPlugin.hiddenColumns);
        if (!!hotSettings.hiddenColumns && !!hotSettings.hiddenColumns.columns) {
          hotSettings.hiddenColumns.columns = hiddenAndCollapsedCols;
        }
        hiddenColumnsPlugin.updatePlugin();
      }
      this.hotTable.render()
      return
    }
    this.subareaIndex = props.subareaIndex
    const maxColNum = Math.max(...data.map(d=> d.length))
    const hiddenRows:number[] = props.hiddenRows
    const hiddenCols:number[] = props.hiddenCols
    let colWidths:number[] = content.cellProps.colWidths
    const sumColWidths = colWidths.reduce((a, w) => a + w);
    if (this.resizeWidth && this.width > sumColWidths) {
      colWidths.forEach((colWidth, i) => {
        colWidths[i] = colWidth * this.width / sumColWidths
      });
      this.width = colWidths.reduce((a, w) => a + w);
    }
    const sumColHeight = this.CELL_HEIGHT * (endRowNum - startRowNum + 1);
    const cellProcessor = preprocessors[this.customPreprocessor]
    this.currentHeight = Math.min(this.height, sumColHeight)
    this.bindingPaths = parseBindingPaths(content.cellProps.bindingPaths).map(r => r || [])
    this.cellProps = content.cellProps
    const expression = expression_in_data(data)
    this.preprocessRefersCells = []
    this.preprocess = (data:any[][]) => {
      const r = this.preprocessRefersCells
      const d = expression(data, r)
      this.calcCells.lexer = null;
      this.calcCells.promise = cellProcessor.preprocess(d, r);
    }
    this.mainPreprocess = (data:any[][]) => {
      const r = this.preprocessRefersCells
      const d = expression(data, r)
      if (this.calcCells.lexer === null) {
        this.calcCells.promise.then((lxd) => {
          this.calcCells.lexer = lxd;
          cellProcessor.postprocess(d, r, lxd, this.hotTable);
          this.hotTable.render();
        });
      } else {
        cellProcessor.postprocess(d, r, this.calcCells.lexer, this.hotTable);
        this.hotTable.render();
      }
    }
    this.preprocess(data)

    // Create cell renderer
    const customRenderer = createRenderer(this.cellProps, this.CELL_HEIGHT);

    let _startRowNum = 0
    if (hiddenCols && hiddenCols.length > 0) {
      for (let i = 0; i < endRowNum; i++) {
        if (hiddenCols.indexOf(i) === -1) {
          _startRowNum = i
          break
        }
      }
    }
    this.options = {
      data: data,
      height: this.currentHeight,
      hiddenColumns: {
        columns: hiddenCols
      },
      hiddenRows: hiddenRows.length > 0 ?{rows: hiddenRows} : false,
      colWidths: colWidths,
      rowHeights: this.CELL_HEIGHT,
      columnHeaderHeight: this.CELL_HEIGHT,
      cells: customRenderer.cells,
      mergeCells: props.mergeCells,
      formulas: this.usesBuiltInFormula,
      stretchH: 'none',
      autoRowSize: false,
      autoColumnSize: false,
      fixedColumnsLeft: props.fixedColumnsLeft,
      fixedRowsTop: props.fixedRowsTop,
      wrapText: this.wrapText,
      licenseKey: this.LICENSE_KEY,
      wordWrap: false,
      trimDropdown:false,
      undo: true,
      afterGetColHeader: customRenderer.headerRenderer,
      initCollapsedCols: props.initCollapsedCols,
      initCollapsedRows: props.initCollapsedRows,
      startRowNum: _startRowNum,
      endRowNum: !!this.cellProps.headerEndRowNum ? endRowNum - this.cellProps.headerEndRowNum - 1 : endRowNum,
      startColNum: startColNum,
      endColNum: endColNum,
      afterInit: function() {
        const collapsibleColumnsPlugin = this.getPlugin('collapsibleColumns')
        if (collapsibleColumnsPlugin.isEnabled()) collapsibleColumnsPlugin.collapseAll()
      },
      scrollRegionHeightAdjustment: this.scrollRegionHeightAdjustment,
    }

    // Process nested headers
    const columnSorting = (_sortSettings:{column:number, sortOrder:string}[]) => {
      if (!!_sortSettings && _sortSettings.length > 0) {
        let defaultSorting = _sortSettings.find(x => !!x.sortOrder);
        return !!defaultSorting ? defaultSorting : true
      } else {
        return false;
      }
    }

    if (this.hotTable) {
      this.ngZone.runOutsideAngular(() =>
        this.hotTable.updateSettings(this.options, false)
      )
    }
    else {
      if (nestedHeaders && nestedHeaders.length > 0) {
        Object.assign(this.options, {
          nestedHeaders: nestedHeaders,
          // fixedRowsTop: 0,
          filters: !!this.cellProps.filterSettings && this.cellProps.filterSettings.length > 0,
          dropdownMenu: ['filter_by_condition2', 'filter_action_bar', 'filter_by_value'],
          columnSorting: columnSorting(this.cellProps.sortSettings),
          sortIndicator: true,
        })
      }
      const colOutlineDepth: any[]=this.cellProps.colOutlineDepth || [];
      const rowOutlineDepth: any[]=this.cellProps.rowOutlineDepth || [];
      setGroupingHeader(colOutlineDepth, rowOutlineDepth, this)

      Object.assign(this.options, {
        width: this.width,
      })
      this.options.closedColumnGroups = new Array()
      const collapsibleColumns = this.options.collapsibleColumns
      if (collapsibleColumns && collapsibleColumns.length > 0) {
        collapsibleColumns.forEach(x => {
          this.options.closedColumnGroups.push({row: x.row, fromCol: x.col, toCol: x.toCol})
        })
      }
      Handsontable.cellTypes.registerCellType('icon', {
        editor: Handsontable.editors.BaseEditor,
        renderer: Handsontable.renderers.HtmlRenderer,
        className: 'htIcon',
      })
      this.hotTable = new Handsontable(
        this.hookPoint.nativeElement, this.options
      )
      Handsontable.hooks.add('afterUpdateSettings',
        (settings:any) => {
          const filtersPlugin = this.hotTable.getPlugin('filters')
          if (filtersPlugin.isEnabled()) {
            filtersPlugin.filter()
          }
          const collapsibleColumnsPlugin = this.hotTable.getPlugin('collapsibleColumns')
          const closedColumnGroups = this.hotTable.getSettings().closedColumnGroups;
          if (collapsibleColumnsPlugin.isEnabled() && closedColumnGroups && closedColumnGroups.length > 0) {
            closedColumnGroups.forEach(x => {
              if (x) collapsibleColumnsPlugin.collapseSection({row: x.row, col: x.fromCol})
            })
          }
        },
        this.hotTable,
      )
      Handsontable.hooks.add('afterRender',
        function(isForced:boolean) {
          // [ARA-9140] Rest Fixed Left table's position
          try {
            var fixedColumnsLeft = this.view.wt.getSetting('fixedColumnsLeft');
            var calculator = this.view.wt.wtViewport.columnsRenderCalculator;
            if (fixedColumnsLeft > 0 && calculator.startColumn < fixedColumnsLeft) {
              var instance = this.getInstance();
              var hiddenRowsPlugin = instance.getPlugin('hiddenRows');
              var hiddenColumnsPlugin = instance.getPlugin('hiddenColumns');
              var firstRenderedRow = this.view.wt.wtTable.getFirstRenderedRow();
              while(hiddenRowsPlugin.isHidden(firstRenderedRow)) { firstRenderedRow++; }
              while(hiddenColumnsPlugin.isHidden(fixedColumnsLeft)) { fixedColumnsLeft++; }

              var overlayCloneTableRest = this.view.wt.wtOverlays.leftOverlay.clone.wtTable.TABLE.getBoundingClientRect();
              var fixedLeftCellRect = instance.getCell(firstRenderedRow, fixedColumnsLeft).getBoundingClientRect();
              var mainTableRect = this.view.wt.wtTable.TABLE.getBoundingClientRect()
              var startPosition = overlayCloneTableRest.width - fixedLeftCellRect.left + mainTableRect.left;
              if (startPosition > 0 && startPosition < calculator.startPosition) {
                var topOverlay = this.view.wt.wtOverlays.topOverlay,
                    bottomOverlay = this.view.wt.wtOverlays.bottomOverlay;
                calculator.startPosition = startPosition;
                this.view.wt.wtTable.spreader.style.left = startPosition + 'px';
                if (topOverlay) {
                  topOverlay.clone.wtTable.spreader.style.left = startPosition + 'px';
                }
                if (bottomOverlay) {
                  bottomOverlay.clone.wtTable.spreader.style.left = startPosition + 'px';
                }
              }
            }
          } catch (e) {}
        }
      )
      Handsontable.hooks.add('beforeOnCellMouseDown',
        function(event, coords, td) {
          if (event.target.classList.contains('colHeader')) {
            var collapsibleColumnsPlugin = this.getPlugin('CollapsibleColumns');
            var collapsibleIndicator = td.querySelector('div.collapsibleIndicator.expanded');
            if (collapsibleColumnsPlugin.isEnabled() && collapsibleIndicator) {
              event.stopImmediatePropagation();
              collapsibleColumnsPlugin.eventManager.fireEvent(collapsibleIndicator, 'mousedown');
            }
          }
        }
      )
      Handsontable.hooks.add('afterDropdownMenuShow',
        (instance:any) => {
          var filtersPlugin = this.hotTable.getPlugin('filters')
          if (filtersPlugin.isEnabled()) {
            filtersPlugin.components.get('filter_by_value').elements[0].onClearAllClick({preventDefault: function() {}});
          }
        },
        this.hotTable,
      )
      Handsontable.hooks.add('afterToggleCollapsibleSection',
        (action:string, coords:{row:number, col:number}, colspan:number) => {
          let closedColumnGroups:{row:number, fromCol:number, toCol:number}[] = this.hotTable.getSettings().closedColumnGroups
          if (!closedColumnGroups) {
            closedColumnGroups = []
            this.hotTable.getSettings().closedColumnGroups = closedColumnGroups
          }
          let targetIndex = closedColumnGroups.findIndex(c => c.row == coords.row && c.fromCol == coords.col);
          switch (action) {
            case 'collapse':
              if (targetIndex !== -1) {
                closedColumnGroups[targetIndex].toCol = coords.col + colspan - 1
              } else {
                closedColumnGroups.push({row: coords.row, fromCol: coords.col, toCol: coords.col + colspan - 1})
              }
              break;
            case 'expand':
              if (targetIndex !== -1)
                closedColumnGroups.splice(targetIndex, 1)
              break;
            default:
              break;
          }
        },
        this.hotTable
      )
      Handsontable.hooks.add('beforeChange',
        (changes:any[][], source:string) => {
          let changed = false
          let needsRecalculation = false
          changes.forEach(change => {
            const rowIdx   = this.hotTable.toPhysicalRow(change[0])
            const colIdx   = change[1]
            const oldValue = change[2]
            const newValue = change[3]
            if (this.isChanged(oldValue, newValue)) {
              changed = true
              // this.cellProps.bgColor[rowIdx][colIdx] = CHANGED_CELL_COLOR.key;
              this.options.data[rowIdx][colIdx] = newValue
            }
            if (this.preprocessRefersCells[rowIdx][colIdx]) {
              needsRecalculation = true
            }
          })
          if (!changed) return
          if (!needsRecalculation) return
          this.mainPreprocess(this.options.data)
        },
        this.hotTable,
      )
      Handsontable.hooks.add('afterChange',
        (e:Event, source:string) => {
          if(source === 'loadData'){
              //API実行時などloadData時
              this.hotTable.undoRedo.doneActions = this.undoStack.concat()
          }else{
            // セル編集時
            this.undoStack = this.hotTable.undoRedo.doneActions.concat()
          }
          this.updateCellValue(e, source)
        },
        this.hotTable,
      )
      Handsontable.hooks.add('afterSelection',
        (r:any, c:any, r2:any, c2:any) => {
          this.updateActiveCellPosition(r,c)
          if (event && event.type === 'mousedown'
              && (event.target === this.hotTable.getCell(r, c, true) || this.hotTable.getCellMeta(r, c).type === 'icon')) {
            this.notifyEvent('click', r, c)
          }
        },
        this.hotTable,
      )
    }
    initCollapseSection(this.hotTable);
    this.mainPreprocess(data);
  }

  ngOnDestroy() {
    if (this.hotTable) {
      this.hotTable.destroy()
      this.hotTable = null
    }
  }

  updateActiveCellPosition(_row:number, _col:number):void {
    if (!this.viewModelPath) return
    const row = this.hotTable.toPhysicalRow(_row)
    const col = _col
    const selectedCells:number[][] = this.hotTable.getSelected()
    var activeCells = [];
    if(selectedCells.length > 1){
      // Ctrl+クリックの複数選択を含む場合
      selectedCells.forEach((selectCell,i,array) =>  {
        var coords = this.createSelectCells(selectCell)
        if(coords.length===2 && typeof(coords[0])==='number'){
          //coordsが数字配列の場合
          activeCells.push(coords)
        }else{
          //coordsが配列の配列の場合
          coords.length > 1 ?
          // 範囲選択なので分解処理
          coords.forEach(v => activeCells.push(v)):
          // 単一なのでそのまま
          activeCells.push(coords)
        }
      })
    }else if (selectedCells.length === 1){
      // 単一セル選択　or　Shift+矢印による複数選択 or Shift+クリックによる複数選択
      activeCells = this.createSelectCells(selectedCells[0])
    }
    //単一セル選択用ViewModelPath
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath + '.active_cell_position',
      (m) => [row, col],
      {id:this.id, type:'change', source:{value:[row, col]}},
      'update active cell postion',
    ))
    //複数セル選択用ViewModelPath
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath + '.active_cell_positions',
      (m) => activeCells,
      {id:this.id, type:'change', source:{value:activeCells}},
      'update active cell postions',
    ))
  }

  notifyEvent(type:string, _row:number, _col:number):void {
    const row = this.hotTable.toPhysicalRow(_row)
    const col = _col
    const bindingPath = this.bindingPathAt(row, col)
    if (!bindingPath) return
    this.eventHub.next({
      id: this.id,
      type: `spreadsheet-internal::${type}`,
      source: {...bindingPath, value:this.contentOn(bindingPath)},
    })
  }

  bindingPathAt(row:number, col:number):BindingInfo {
    const rowNum = row
    const colNum = col
    const bindingPaths = this.bindingPaths
    const bindingPath = bindingPaths[rowNum] && bindingPaths[rowNum][colNum]
    return bindingPath
  }

  updateCellValue(e:any, source:string):void {
    if (!e || source == 'populateFromArray' || source == 'ObserveChanges.change') return
    for(var i = 0; i < e.length; i++){
      const rowNum = this.hotTable.toPhysicalRow(e[i][0])
      const colNum = e[i][1]
      const bindingPath = this.bindingPathAt(rowNum, colNum)
      if (!bindingPath) continue
      const beforeValue = e[i][2]
      const value = e[i][3]
      if (!this.isChanged(beforeValue, value)) continue
      const rowIdx = rowNum
      const colIdx = colNum

      const path = bindingPath.iterable ? bindingPath.groupPath : bindingPath.path
      const updatedContent = this.updatedContentOn(bindingPath, value)
      this.store.dispatch(this.actionCreator.mergeViewModel(
        this.viewModelPath + '.' + path,
        (m) => updatedContent,
        {id:this.id, type:'change', source:{value:updatedContent}},
        `update by ${this.id}`,
      ))
      bindingPath.upperGroups().forEach(g => {
        const value = g.data(this.options.data)
        if (Array.isArray(value) || (typeof value === 'object')) return
        this.store.dispatch(this.actionCreator.mergeViewModel(
          this.viewModelPath + '.' + g.path,
          (m) => value,
          {id:this.id, type:'change', source:{value:value}},
          `update by ${this.id}(${bindingPath.path})`,
        ))
      })
      this.store.dispatch(this.actionCreator.updateViewModel(
        'lastActivatedModelPath',
        (m) => bindingPath.path,
        {id:this.id, type:'change', source:{value:bindingPath}},
        'update last activated view model path',
      ))
      this.notifyEvent('change', e[i][0], e[i][1])
    }
  }

  contentOn(bindingPath:BindingInfo):any {
    if (bindingPath.iterable) {
      return bindingPath.record(this.options.data)
    }
    return bindingPath.data(this.options.data)
  }

  updatedContentOn(bindingPath:BindingInfo, value:any):any {
    const record = {}
    if (bindingPath.iterable) {
      bindingPath.group().forEach(item => {
        record[item.memberKey] = item.data(this.options.data)
      })
      record[bindingPath.memberKey] = value;
    }
    return bindingPath.iterable ? record : value
  }
  /**
   * 現在選択しているセルを2次元配列として返す　
   * 1,1から2,2を複数選択した場合、 [1,1],[1,2],[2,1],[2,2]として返す。
   * @param cells
   */
  createSelectCells(cells:number[]){
    const startRow = this.hotTable.toPhysicalRow(cells[0])
    const startCol = cells[1]
    const endRow = this.hotTable.toPhysicalRow(cells[2])
    const endCol = cells[3]
    if(startRow === endRow && startCol === endCol){
      //単一セルのクリック
      return [startRow, startCol]
    }
    var selectCells=[]
    if(startRow < endRow && startCol < endCol){
      //パターン(1)
      for(var i=startRow; i<=endRow; i++){
        for(var j=startCol; j<=endCol; j++){
          selectCells.push([i,j])
        }
      }
    }else if(startRow < endRow && startCol > endCol){
      //パターン(2)
      for(var i=startRow; i<=endRow; i++){
        for(var j=endCol; j<=startCol; j++){
          selectCells.push([i,j])
        }
      }
    }else if(startRow > endRow && startCol < endCol){
      //パターン(3)
      for(var i=endRow; i<=startRow; i++){
        for(var j=startCol; j<=endCol; j++){
          selectCells.push([i,j])
        }
      }
    }else if(startRow > endRow && startCol > endCol){
      //パターン(4)
      for(var i=endRow; i<=startRow; i++){
        for(var j=endCol; j<=startCol; j++){
          selectCells.push([i,j])
        }
      }
    }else if(startRow === endRow && startCol < endCol){
      //パターン(5)
      var i=endRow
      for(var j=startCol; j<=endCol; j++){
        selectCells.push([i,j])
      }
    }else if(startRow < endRow && startCol === endCol){
      //パターン(6)
      var j=endCol;
      for(var i=startRow; i<=endRow; i++){
        selectCells.push([i,j])
      }
    }else if(startRow === endRow && startCol > endCol){
      //パターン(7)
      var i=endRow
      for(var j=endCol; j<=startCol; j++){
        selectCells.push([i,j])
      }
    }else if(startRow > endRow && startCol === endCol){
      //パターン(8)
      var j=endCol;
      for(var i=endRow; i<=startRow; i++){
        selectCells.push([i,j])
      }
    }
    return selectCells
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}



// WEBPACK FOOTER //
// ./src/widgets/spread_sheet/spread-sheet/spread-sheet.component.ts